var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluemoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#163E6E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C27.5 12 32 16.5 32 22C32 27.5 27.5 32 22 32C16.5 32 12 27.5 12 22V19",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23L12 19L8 23",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8C29.7 8 36 14.3 36 22C36 29.7 29.7 36 22 36",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18.2727V17H19V18.2727H21.2273C22.0558 18.2727 22.7552 18.806 23.0186 19.5455H19V20.8182H23.0186C22.888 21.1893 22.6457 21.5109 22.3249 21.7388C22.0042 21.9667 21.6207 22.0897 21.2273 22.0909H19V23.6271L22.5547 27.1818H24.3544L20.5362 23.3636H21.2273C21.9603 23.3627 22.6706 23.1089 23.2384 22.6452C23.8062 22.1816 24.1967 21.5363 24.3442 20.8182H26V19.5455H24.3442C24.2466 19.0823 24.0456 18.6472 23.7562 18.2727H26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluemoney);
export default __webpack_public_path__ + "static/media/bluemoney.12be19c75c486a753a92e65f42510569.svg";
export { ForwardRef as ReactComponent };